import { make } from 'vuex-pathify'

const state = {
    id: null,
    nombre: null,
    email: null,
}

const mutations = {
    ...make.mutations(state),

    /**
     * Reset state.
     * @param {Object} current 
     */
    reset(current) {
        Object.assign(current, state)
    },

    /**
     * Fill the state.
     * @param {Object} state 
     * @param {Object} user 
     */
    set(state, user) {
        for (const key in state) {
            if (user.hasOwnProperty(key)) {
                state[key] = user[key]
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
}